(function(){
  function initConcierge(root){
    var section = root.querySelector('[data-vp-concierge]');
    if(!section || section.dataset.vpInit) return;
    section.dataset.vpInit = '1';

    var targets = section.querySelectorAll('.vp-reveal');
    if(!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches){
      targets.forEach(function(el){ el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){ entry.target.classList.add('in'); io.unobserve(entry.target); }
        });
      }, {threshold:0, rootMargin:'0px 0px -8% 0px'});
      targets.forEach(function(el){ io.observe(el); });
      setTimeout(function(){ targets.forEach(function(el){ el.classList.add('in'); }); }, 3800);
    }

    /* ---- subtle cursor-follow on the portrait ---- */
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var media = section.querySelector('[data-vp-concierge-media]');
    if(!media || reduce) return;
    var img = media.querySelector('img');
    if(!img) return;

    section.addEventListener('mousemove', function(e){
      var r = section.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      img.style.transform = 'scale(1.06) translate(' + (-x * 14).toFixed(1) + 'px,' + (-y * 14).toFixed(1) + 'px)';
    });
    section.addEventListener('mouseleave', function(){
      img.style.transform = 'scale(1.06)';
    });
  }
  function boot(){ initConcierge(document); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(e){ initConcierge(e.target); });
})();